import React from 'react';
import { ArrowRight, CalendarCheck2, ShieldCheck } from 'lucide-react';

export default function Cta() {
  return (
    <section id="contact">
      <div className="container-x">
        <div className="cta-card reveal">
          <div className="cta-glow-a" />
          <div className="cta-glow-b" />
          <div className="cta-inner">
            <span className="eyebrow"><CalendarCheck2 size={13}/> Free strategy call · 30 min</span>
            <h2 className="section-heading" style={{ marginTop: 24 }}>
              Ready to fill your calendar with <span className="text-gradient">your dream clients?</span>
            </h2>
            <p>Schedule your free strategy call today, we'll map out exactly how our AI lead generation system can book qualified meetings for your business</p>
            <div className="cta-actions">
              <a className="btn-primary animate-pulseGlow" href="https://cal.com/one-up-n0typj/discovery" target="_blank" rel="noopener noreferrer">Start the Process <ArrowRight size={16}/></a>
            </div>
            <div className="cta-foot">
              <ShieldCheck size={14} /> By scheduling a call, you agree to our privacy policy. We'll never share your information.
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
